export default __webpack_public_path__ + "static/media/check.06c31cf8.svg";